import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../../features/utils";

export async function submitTriageConciergeCare({ state, actions, valuedata }) {
    const { triageRequest } = state
    const { sessionId } = triageRequest
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    const encounterToken = localStorage.getItem('token')

    { valuedata.hasOwnProperty('hotelname') ? "" : valuedata.hotelname = "" }
    { valuedata.hasOwnProperty('roomnumber') ? "" : valuedata.roomnumber = "" }

    const data = {
        identifier: sessionId,
        token: encounterToken,
        locationType: valuedata.locationType,
        hotelName: valuedata.hotelname,
        hotelRegisteredTo: "",
        hotelPhone: valuedata.phone,
        address: valuedata.address,
        roomNumber: valuedata.roomnumber,
        serviceAddress: "",
        comments: valuedata.comments,
        unit: "",
        country: valuedata.country,
        state: valuedata.state,
        city: valuedata.city,
        jwtAccessToken : jwtAccess_Token,
        accessToken : access_Token,

    }

    actions.sendTriageRequest({ action: 'submitConciergeCare', data })
}